import { render, staticRenderFns } from "./Grid1.vue?vue&type=template&id=2951fe1a&scoped=true&"
import script from "./Grid1.vue?vue&type=script&lang=ts&"
export * from "./Grid1.vue?vue&type=script&lang=ts&"
import style0 from "./Grid1.vue?vue&type=style&index=0&id=2951fe1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2951fe1a",
  null
  
)

export default component.exports